'use client';
import React from 'react';
import { useModel } from '@/context/ModelContext';
import InputRow from './InputRow';

export default function OtherSection() {
  const { assumptions, updateAssumption } = useModel();

  return (
    <div>
      <InputRow
        label="Discount Rate / WACC Proxy (for NPV)"
        unit="% per annum"
        note="Weighted Average Cost of Capital — used as hurdle rate for NPV calculation"
        confidence="Medium"
        value={assumptions?.discountRate}
        onChange={(v) => updateAssumption('discountRate', v)}
        min={8}
        max={30}
        step={0.5}
        isPercent
      />
      <InputRow
        label="Annual Inflation on Fixed Costs"
        unit="% per year"
        note="Applied annually to Land Lease, Salaries, and Insurance from Year 2 onwards"
        confidence="Medium"
        value={assumptions?.inflationFixedCosts}
        onChange={(v) => updateAssumption('inflationFixedCosts', v)}
        min={0}
        max={15}
        step={0.5}
        isPercent
      />
      <div className="mt-3 p-3 bg-warning-bg border border-amber-200 rounded-lg">
        <p className="text-xs text-warning font-semibold mb-1">Sensitivity Note</p>
        <p className="text-xs text-muted-foreground">
          Discount rate and fixed cost inflation have a moderate impact on NPV but minimal effect on
          IRR. Increasing WACC from 14% to 18% reduces NPV significantly but the project remains
          strongly viable given the high IRR. Fixed cost inflation of 4% is conservative — actual
          CPI may be lower.
        </p>
      </div>
    </div>
  );
}
